import { Component, OnDestroy, OnInit } from '@angular/core';
import { MaterialModule } from '../../../material.module';
import { CommonModule, DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgxEditorComponent, NgxEditorMenuComponent, Editor, Toolbar } from 'ngx-editor';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TextMaskDateDirective } from '../../../Directives/text-mask-date-directive.directive';
import moment from 'moment';
import { Router } from '@angular/router';
import { NoteService } from '../notesofaccounts/note.service';
import { CharitiesService } from '../charities/services/charities.service';
import Swal from 'sweetalert2';
import { CustomDateAdapter } from '../../../Shared/common/ng-date-parse-adapter';
import { MatSelectChange } from '@angular/material/select';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';
import { NotesDatashareService } from '../notes/services/notes-datashare.service';
import { RolesModel } from '../../../Data/Models/Users/roles-model';
import { UsermanagementService } from '../../../services/apps/usermanagement/usermanagement.service';
import { MatRadioChange } from '@angular/material/radio';
import { MessageServiceService } from '../../../Shared/common/message-service.service';
import { MatDialog } from '@angular/material/dialog';
import { InputRestrictionDirective } from '../../../Directives/input-restriction.directive';
import { ValidateOnTouchDirective } from '../../../Directives/validate-on-touch.directive';
import { AutoupperCaseDirective } from '../../../Directives/autoupper-case.directive';


@Component({
  selector: 'app-independent-examiner-report',
  imports: [MaterialModule, TablerIconsModule, MatDatepickerModule, NgxEditorComponent, NgxEditorMenuComponent, CommonModule, ReactiveFormsModule, TextMaskDateDirective, InputRestrictionDirective, ValidateOnTouchDirective, AutoupperCaseDirective],
  templateUrl: './independent-examiner-report.component.html',
  styleUrl: './independent-examiner-report.component.scss',
  providers: [{ provide: DateAdapter, useClass: CustomDateAdapter },
  { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS }, DatePipe],


})

export class IndependentExaminerReportComponent implements OnInit, OnDestroy {
  form: FormGroup;
  editor: Editor;
  editor2: Editor;
  editor3: Editor;
  editor4: Editor;
  editor5: Editor;
  charityID: any | number | null;
  currentPeriod: any | null;
  ProfessionalAdvisorsDetails: any = [];
  ProfessionalAdvisorsDetails_count: number = 0;
  filteredAdvisors1: any = [];
  AccountPeriodGrid: any;
  charityName: any = null;
  endDate: any;
  BasicInformation: any;
  isdirty: any;
  accountBodyValue: any;
  CharithDetails: any;
  apFinalised: boolean = false
  isSelected: string = '';
  SubmissionStatus: any;
  ProfessionalAdvisorsCommonForm: FormGroup;
  private pasteHandler!: (event: ClipboardEvent) => void;
  addAdvisorbtn: boolean = true;
  updateAdvisorbtn: boolean = false;
  edithead: boolean = false;
  ShowSpinner: boolean = false;
  AllCountriesList: any = [];



  constructor(private service: NoteService, private router: Router, private Charity_Service: CharitiesService,
    private datashare: NotesDatashareService, public Charities_Service: CharitiesService, private _UsermanagementService: UsermanagementService,
    private dataShareService: CharityDataShareServiceService, private sharedService: CharityDataShareServiceService, private msgService: MessageServiceService, public dialog: MatDialog) {


  }

  ngOnInit(): void {
    // this.dataShareService.updateAccountReportType('Independent Examiner');
    //this.sharedService.finalStatus$.subscribe((value: any) => {
    //  this.apFinalised = value != '' && value == 'Completed'
    //  if (this.apFinalised) {
    //    this.form.get('examinerName')?.disable()
    //    this.form.get('approvalDate')?.disable()
    //    this.form.get('accountingBody')?.disable()
    //  }
    //  else {

    //  }
    //  this.SubmissionStatus = localStorage.getItem('SubmissionStatus');
    //})
    this.charityID = localStorage.getItem('currentCharityID') != '' ? localStorage.getItem('currentCharityID') : 0
    this.currentPeriod = localStorage.getItem('currentPeriod')
    this.Getbasicinformation()
    this.GetUserAccess();
    this.createform();
    this.CreateProfessionalAdvisorsCommonForm();
    this.GetAllCountries();




    //this.GetProfessionalAdvisorsDetails();
    this.editor = new Editor();
    this.enablePlainTextPaste();
    //this.GetIndependentExaminerDetails();
    this.datashare.isdirty$.subscribe(value => {
      this.isdirty = value
    })
    this.editor2 = new Editor();
    this.editor3 = new Editor();
    this.editor4 = new Editor();
    this.editor5 = new Editor();
  }


  UserRoleAccess: RolesModel;
  GetUserAccess() {
    this.ShowSpinner = true;
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      if (data.entity.length) {
        this.ShowSpinner = false;
        this.UserRoleAccess = data.entity[0]
      }
      this.sharedService.finalStatus$.subscribe((value: any) => {
        this.apFinalised = value != '' && value == 'Completed'
        if (this.apFinalised) {
          this.form.get('examinerName')?.disable()
          this.form.get('approvalDate')?.disable()
          this.form.get('accountingBody')?.disable()
        }
        else {

        }
        this.SubmissionStatus = localStorage.getItem('SubmissionStatus');
      })
    });
  }

  AdvisorsID: any = null; ExName: any = []; ExId: any = [];
  onTrusteeChange(event: MatSelectChange, type?: any): void {
    debugger
    this.ExName = this.form.get('examinerName')?.value
    if (this.ExName) {
      this.ExId = [];
      this.ExId = this.ExName;
    }
    const selectedTrusteeId = event.value;
    var data = this.filteredAdvisors1?.filter((x: { professionalAdvisors_Name: any; }) => x.professionalAdvisors_Name == selectedTrusteeId)[0];
    const advisorId = data?.advisorsId;
    this.form.get('AdvisorsID')?.setValue(advisorId);
    var selectedTrustee: any
    if ((selectedTrusteeId && type == 'selected')) {
      this.form.get('examinerName')?.setErrors(null)
      //selectedTrustee = this.trusteesList.find((t: any) => t.trustee_Id === selectedTrusteeId);
      this.form.patchValue({
        trusteeName: selectedTrustee?.name
      });
    } else {
      if (this.form.get('examinerName')?.getRawValue() == 0) {
        this.form.get('examinerName')?.setErrors({ required: true })
      }
    }

  }
  ischecked: boolean = false
  createform() {
    this.form = new FormGroup({
      independentExaminerReportId: new FormControl(0),
      reportDescription: new FormControl('', [
        Validators.required
      ]),
      responsibilitiesDescription: new FormControl('', [
        Validators.required
      ]),
      independentDescription: new FormControl('', [
        Validators.required
      ]),
      reportScotlandDescription: new FormControl('', [Validators.required]),
      responsibilitiesExaminerDescription: new FormControl('', [Validators.required]),
      basisIndependentDescription: new FormControl('', [Validators.required]),
      independentScotlandDescription: new FormControl('', [Validators.required]),

      reportNIDescription: new FormControl('', [Validators.required]),
      responsibilitiesExaminerNIDescription: new FormControl('', [Validators.required]),
      basisIndependentNIDescription: new FormControl('', [Validators.required]),
      independentNIDescription: new FormControl('', [Validators.required]),

      matter_of_Concern: new FormControl(this.ischecked),
      AdvisorsID: new FormControl(null),
      examinerName: new FormControl(''),
      approvalDate: new FormControl(null),
      accountingBody: new FormControl('Other/None'),
      CharityID: new FormControl(this.charityID),
      FinancialPeriodsID: new FormControl(this.currentPeriod),
      CreatedDate: new FormControl(new Date()),
      Createdby: new FormControl(101),
      Modifiedby: new FormControl(101),
      ModifiedDate: new FormControl(new Date()),
      CentralUserId: new FormControl(101),
      UserId: new FormControl(101)
    });
    //this.form.get('reportDescription')?.valueChanges.subscribe(value => {
    //  //  alert('')
    //  debugger
    //  //const plainText = value?.replace(/<[^>]*>/g, '') || '';
    //  const plainText = value
    //  if (plainText.length > 2500) {
    //    const trimmedText = plainText.substring(0, 2500);
    //    const safeHtml = trimmedText
    //    this.form.get('reportDescription')?.setValue(safeHtml, { emitEvent: false });
    //  }
    //});


    this.form.get('reportDescription')?.valueChanges.subscribe(value => {
      if (!value) return;

      const plainText = value.replace(/<[^>]*>/g, '');
      const decodedText = decodeHtmlEntities(plainText);

      if (decodedText.length > 2500) {
        const trimmedText = decodedText.substring(0, 2500);
        this.form.get('reportDescription')?.setValue(trimmedText, { emitEvent: false });
      }
    });
    this.form.get('independentDescription')?.valueChanges.subscribe(value => {
      if (!value) return;

      const plainText = value.replace(/<[^>]*>/g, '');
      const decodedText = decodeHtmlEntities(plainText);

      if (decodedText.length > 2500) {
        const trimmedText = decodedText.substring(0, 2500);
        this.form.get('independentDescription')?.setValue(trimmedText, { emitEvent: false });
      }
    });
    this.form.get('responsibilitiesDescription')?.valueChanges.subscribe(value => {
      if (!value) return;

      const plainText = value.replace(/<[^>]*>/g, '');
      const decodedText = decodeHtmlEntities(plainText);

      if (decodedText.length > 2500) {
        const trimmedText = decodedText.substring(0, 2500);
        this.form.get('responsibilitiesDescription')?.setValue(trimmedText, { emitEvent: false });
      }
    });
    this.form.get('reportScotlandDescription')?.valueChanges.subscribe(value => {
      if (!value) return;

      const plainText = value.replace(/<[^>]*>/g, '');
      const decodedText = decodeHtmlEntities(plainText);

      if (decodedText.length > 2500) {
        const trimmedText = decodedText.substring(0, 2500);
        this.form.get('reportScotlandDescription')?.setValue(trimmedText, { emitEvent: false });
      }
    });
    this.form.get('responsibilitiesExaminerDescription')?.valueChanges.subscribe(value => {
      if (!value) return;

      const plainText = value.replace(/<[^>]*>/g, '');
      const decodedText = decodeHtmlEntities(plainText);

      if (decodedText.length > 2500) {
        const trimmedText = decodedText.substring(0, 2500);
        this.form.get('responsibilitiesExaminerDescription')?.setValue(trimmedText, { emitEvent: false });
      }
    });
    this.form.get('basisIndependentDescription')?.valueChanges.subscribe(value => {
      if (!value) return;

      const plainText = value.replace(/<[^>]*>/g, '');
      const decodedText = decodeHtmlEntities(plainText);

      if (decodedText.length > 2500) {
        const trimmedText = decodedText.substring(0, 2500);
        this.form.get('basisIndependentDescription')?.setValue(trimmedText, { emitEvent: false });
      }
    });
    this.form.get('independentScotlandDescription')?.valueChanges.subscribe(value => {
      if (!value) return;

      const plainText = value.replace(/<[^>]*>/g, '');
      const decodedText = decodeHtmlEntities(plainText);

      if (decodedText.length > 2500) {
        const trimmedText = decodedText.substring(0, 2500);
        this.form.get('independentScotlandDescription')?.setValue(trimmedText, { emitEvent: false });
      }
    });
    this.form.get('reportNIDescription')?.valueChanges.subscribe(value => {
      if (!value) return;

      const plainText = value.replace(/<[^>]*>/g, '');
      const decodedText = decodeHtmlEntities(plainText);

      if (decodedText.length > 2500) {
        const trimmedText = decodedText.substring(0, 2500);
        this.form.get('reportNIDescription')?.setValue(trimmedText, { emitEvent: false });
      }
    });
    this.form.get('responsibilitiesExaminerNIDescription')?.valueChanges.subscribe(value => {
      if (!value) return;

      const plainText = value.replace(/<[^>]*>/g, '');
      const decodedText = decodeHtmlEntities(plainText);

      if (decodedText.length > 2500) {
        const trimmedText = decodedText.substring(0, 2500);
        this.form.get('responsibilitiesExaminerNIDescription')?.setValue(trimmedText, { emitEvent: false });
      }
    });
    this.form.get('basisIndependentNIDescription')?.valueChanges.subscribe(value => {
      if (!value) return;

      const plainText = value.replace(/<[^>]*>/g, '');
      const decodedText = decodeHtmlEntities(plainText);

      if (decodedText.length > 2500) {
        const trimmedText = decodedText.substring(0, 2500);
        this.form.get('basisIndependentNIDescription')?.setValue(trimmedText, { emitEvent: false });
      }
    });
    this.form.get('independentNIDescription')?.valueChanges.subscribe(value => {
      if (!value) return;

      const plainText = value.replace(/<[^>]*>/g, '');
      const decodedText = decodeHtmlEntities(plainText);

      if (decodedText.length > 2500) {
        const trimmedText = decodedText.substring(0, 2500);
        this.form.get('independentNIDescription')?.setValue(trimmedText, { emitEvent: false });
      }
    });


    function decodeHtmlEntities(text: string): string {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = text;
      return textarea.value;
    }

  }
  MarkDirty() {
    debugger
    this.datashare.setisdirty(true)
    this.isdirty = true
  }
  limitHtmlContent(html: string, maxLength: number = 2500): string {
    const div = document.createElement('div');
    div.innerHTML = html;

    let charCount = 0;
    const walker = document.createTreeWalker(div, NodeFilter.SHOW_TEXT, null);
    const nodesToRemove: Node[] = [];

    while (walker.nextNode()) {
      const node = walker.currentNode as Text;
      const remaining = maxLength - charCount;

      if (remaining <= 0) {
        nodesToRemove.push(node);
      } else if (node.nodeValue!.length > remaining) {
        node.nodeValue = node.nodeValue!.substring(0, remaining);
        charCount = maxLength;
      } else {
        charCount += node.nodeValue!.length;
      }
    }

    // Remove extra text nodes
    nodesToRemove.forEach(node => node.parentNode?.removeChild(node));

    // Remove empty elements left behind
    const cleanEmptyElements = (element: HTMLElement) => {
      Array.from(element.children).forEach(child => {
        cleanEmptyElements(child as HTMLElement);
        if (
          child.childNodes.length === 0 ||
          (child.childNodes.length === 1 && child.childNodes[0].nodeType === Node.TEXT_NODE && !(child.textContent || '').trim())
        ) {
          child.remove();
        }
      });
    };

    cleanEmptyElements(div);

    return div.innerHTML;
  }

  ngOnDestroy(): void {
    if (this.pasteHandler) {
      document.removeEventListener('paste', this.pasteHandler, true);
    }
    this.editor?.destroy();
  }


  Getbasicinformation() {
    debugger

    const period = localStorage.getItem('currentPeriod');
    const charityId = localStorage.getItem('currentCharityID');
    this.Charities_Service.Getbasicinfo(charityId, period).subscribe((data: any) => {
      debugger
      this.BasicInformation = data
      this.endDate = moment(data[0].current_AP_End_Date).format('DD/MM/YYYY');
      //this.GetProfessionalAdvisorsDetails()
      this.GetCharityDetails()
    })
  }
  private clearValidation(controlNames: string[]) {
    controlNames.forEach(name => {
      const control = this.form?.get(name);
      control?.clearValidators();
      control?.setErrors(null);
      control?.updateValueAndValidity();
    })
  }

  SaveExaminer(): void {
    debugger;
    // Get the value from the form control
    let description: string = this.form.controls['responsibilitiesDescription'].value;

    // Replace all <br> with <br/>
    if (this.form.controls['responsibilitiesDescription'].value) {
      description = description.replace(/<br\s*>/g, '<br/>');
    }

    // If you want to update the form control back
    this.form.controls['responsibilitiesDescription'].setValue(description);

    const ifScotland = this.CharithDetails?.jurisdiction_Charity === 'scotland';
    const ifEngland = this.CharithDetails?.jurisdiction_Charity === 'england_wales';
    const ifNorthernIreland = this.CharithDetails?.jurisdiction_Charity === 'northern_ireland';
    if (ifScotland) {
      if (this.form.controls['reportScotlandDescription'].value == '<p></p>' || this.form.controls['reportScotlandDescription'].value == "") {
        Swal.fire({
          html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Opening Statement is required</p>',
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          showCancelButton: false,
          allowOutsideClick: false
        })
        return;
      }
      //else if (this.form.controls['responsibilitiesExaminerDescription'].value == '<p></p>' || this.form.controls['responsibilitiesExaminerDescription'].value == "") {
      //  Swal.fire({
      //    html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Respective responsibilities of trustees and examiner is required</p>',
      //    iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
      //    confirmButtonText: "OK",
      //    showCancelButton: false,
      //    allowOutsideClick: false
      //  })
      //  return;
      //}
      //else if (this.form.controls['basisIndependentDescription'].value == '<p></p>' || this.form.controls['basisIndependentDescription'].value == "") {
      //  Swal.fire({
      //    html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Basis of independent examiner’s statement is required</p>',
      //    iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
      //    confirmButtonText: "OK",
      //    showCancelButton: false,
      //    allowOutsideClick: false
      //  })
      //  return;
      //}
      else if (this.form.controls['independentScotlandDescription'].value == '<p></p>' || this.form.controls['independentScotlandDescription'].value == "") {
        Swal.fire({
          html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5><p class="f-s-14 p-0 f-w-400 text-black">Independent examiner's statement is required</p>`,
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          showCancelButton: false,
          allowOutsideClick: false
        })
        return;
      }
    }

    else if (ifEngland) {
      if (this.form.controls['reportDescription'].value == '<p></p>' || this.form.controls['reportDescription'].value == "") {
        Swal.fire({
          html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Opening Statement is required</p>`,
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          showCancelButton: false,
          allowOutsideClick: false
        })
        return;
      }
      else if (this.form.controls['responsibilitiesDescription'].value == '<p></p>' || this.form.controls['responsibilitiesDescription'].value == "") {
        Swal.fire({
          html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Responsibilities and basis of report is required</p>`,
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          showCancelButton: false,
          allowOutsideClick: false
        })
        return;
      }
      else if (this.form.controls['independentDescription'].value == '<p></p>' || this.form.controls['independentDescription'].value == "") {
        Swal.fire({
          html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0 f-w-400 text-black"> Independent examiner's statement is required</p>`,
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          showCancelButton: false,
          allowOutsideClick: false
        })
        return;
      }
    }
    else if (ifNorthernIreland) {
      if (this.form.controls['reportNIDescription'].value == '<p></p>' || this.form.controls['reportNIDescription'].value == "") {
        Swal.fire({
          html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0  f-w-400 text-black" > Opening Statement is required</p>',
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          showCancelButton: false,
          allowOutsideClick: false
        })
        return;
      }
      else if (this.form.controls['independentNIDescription'].value == '<p></p>' || this.form.controls['independentNIDescription'].value == "") {
        Swal.fire({
          html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5><p class="f-s-14 p-0 f-w-400 text-black">Independent examiner's statement is required</p>`,
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          showCancelButton: false,
          allowOutsideClick: false
        })
        return;
      }
    }
      this.CurrentDate_Validate({ target: { value: this.form.get('approvalDate')?.value } });

      if (!this.form.get('examinerName')?.value) {
        this.form.get('examinerName')?.setErrors({ required: true });
        this.form.get('examinerName')?.markAsTouched();
      }
    if (ifScotland) {
      this.clearValidation([
        'reportDescription',
        'responsibilitiesDescription',
        'independentDescription',
        'reportNIDescription',
        'responsibilitiesExaminerNIDescription',
        'basisIndependentNIDescription',
        'independentNIDescription'
      ]);
      }
      else if (ifNorthernIreland) {
      this.clearValidation([
        'reportScotlandDescription',
        'responsibilitiesExaminerDescription',
        'basisIndependentDescription',
        'independentScotlandDescription',
        'reportDescription',
        'responsibilitiesDescription',
        'independentDescription'
      ]);
      }
      else {
      this.clearValidation([
        'reportScotlandDescription',
        'responsibilitiesExaminerDescription',
        'basisIndependentDescription',
        'independentScotlandDescription',
        'reportNIDescription',
        'responsibilitiesExaminerNIDescription',
        'basisIndependentNIDescription',
        'independentNIDescription'
      ]);
    }
      if (this.form.invalid) {
        this.form.markAllAsTouched();
        return;
      }

      this.form.controls['approvalDate'].setValue(
        this.DbDateConverter(this.form.controls['approvalDate']?.value)
      );

      const payload = {
        independentExaminerReportId: this.form.get('independentExaminerReportId')?.value,
        reportDescription: this.form.get('reportDescription')?.value,
        ResponsibilitiesDescription: this.form.get('responsibilitiesDescription')?.value,
        IndependentDescription: this.form.get('independentDescription')?.value,
        independentScotlandDescription: this.form.get('independentScotlandDescription')?.value,
        reportScotlandDescription: this.form.get('reportScotlandDescription')?.value,
        responsibilitiesExaminerDescription: this.form.get('responsibilitiesExaminerDescription')?.value,
        basisIndependentDescription: this.form.get('basisIndependentDescription')?.value,
        reportNIDescription: this.form.get('reportNIDescription')?.value,
        responsibilitiesExaminerNIDescription: this.form.get('responsibilitiesExaminerNIDescription')?.value,
        basisIndependentNIDescription: this.form.get('basisIndependentNIDescription')?.value,
        independentNIDescription: this.form.get('independentNIDescription')?.value,
        matter_of_Concern: this.ischecked,
        examinerName: this.form.get('examinerName')?.value,
        approvalDate: this.form.get('approvalDate')?.value,
        accountingBody: this.form.get('accountingBody')?.value,
        charityID: this.form.get('CharityID')?.value,
        financialPeriodsID: this.form.get('FinancialPeriodsID')?.value,
        createdDate: this.form.get('CreatedDate')?.value,
        createdby: this.form.get('Createdby')?.value,
        modifiedby: this.form.get('Modifiedby')?.value,
        modifiedDate: this.form.get('ModifiedDate')?.value,
        centralUserId: this.form.get('CentralUserId')?.value,
        userId: this.form.get('UserId')?.value,
        AdvisorsID: this.form.get('AdvisorsID')?.value,
      };

      this.service.SaveIndependentExaminer(payload).subscribe({
        next: (res) => {
          this.form.markAsPristine();
          this.datashare.setisdirty(false)
          this.isdirty = false
          this.router.navigate(['final-accounts']);

        },
        error: (err) => {
          console.error('API error:', err);
          Swal.fire('Error', 'Something went wrong while saving.', 'error');
        }
      });
  }




  SetDefault() {
    debugger
    this.form.controls['reportDescription'].setValue(this.defaultStatements)
  }



  DefaultStatement(formControlName: any) {
    debugger

    if (this.BasicInformation[0]?.accounting_Method == 'Cash (Receipts & Payments)') {
      this.defaultStatements = {
        reportDescription: `<p>I report to the trustees on my examination of the accounts of ${this.charityName} (the Charity) for the year ended ${this.endDate}. </p>`,

        responsibilitiesDescription: `As the charity trustees of the Trust, you are responsible for the preparation of the accounts in accordance with the requirements of the Charities Act 2011 (the Act).<br/>   

                                      I report in respect of my examination of the Trust’s accounts carried out under section 145 of the 2011 Act and in carrying out my examination, I have followed the applicable Directions given by the Charity Commission under section 145(5)(b) of the Act.`,

        independentDescription: `
                            I have completed my examination. I confirm that no material matters have come to my attention (other than that disclosed below *) in connection with the examination which gives me cause to believe that in, any material respect: 
                            <ul>
                            <li> accounting records were not kept in accordance with section 130 of the Act or </li>
                            <li> the accounts do not accord with the accounting records </li>
                            </ul>
                            <p>I have no concerns and have come across no other matters in connection with the examination to which attention should be drawn in order to enable a proper understanding of the accounts to be reached.</p>`,

      }
    }

    else {
      this.defaultStatements = {
        reportDescription: `<p>
                             I report to the trustees on my examination of the accounts of
                             ${this.charityName} (the Charity) for the year ended ${this.endDate}.
                           </p>`,
        responsibilitiesDescription:
          `<p>
                             As the charity's trustees, you are responsible for the preparation of the accounts
                             in accordance with the requirements of the Charities Act 2011 (the Act).
                           </p>
                           <p>
                             I report in respect of my examination of the Trust’s accounts carried out under section 145
                             of the 2011 Act and in carrying out my examination, I have followed all the applicable Directions
                             given by the Charity Commission under section 145(5)(b) of the Act.
                           </p> `,
        independentDescription: `<p>
                             The charity’s gross income exceeded £250,000 and I am qualified to undertake the examination
                             by being a qualified member of ${this.accountBodyValue == undefined || this.accountBodyValue == null || this.accountBodyValue == '' ? this.accountBodyValue = 'Other/None' : this.accountBodyValue}.
                           </p>
                           <p>
                             I have completed my examination. I confirm that no material matters have come to my attention
                             (other than that disclosed below *) in connection with the examination which gives me cause
                             to believe that in, any material respect:
                           </p>
 
                           <ul>
                           <li>the accounting records were not kept in accordance with section 130 of the Charities Act; or</li>
                           <li>the accounts did not accord with the accounting records; or</li>
                           <li>the accounts did not comply with the applicable requirements concerning the form and content of accounts set out in the Charities (Accounts and Reports) Regulations 2008 other than any requirement that the accounts give a ‘true and fair’ view which is not a matter considered as part of an independent examination.</li>
                           </ul>
 
                           <p>
                             I have no concerns and have come across no other matters in connection with the examination
                             to which attention should be drawn in order to enable a proper understanding of the accounts
                             to be reached.
                           </p> `
      }
    }

    const selected = this.defaultStatements[formControlName];
    if (selected) {
      this.form.patchValue({
        [formControlName]: selected
      }, { emitEvent: false });
    }
    /* this.form.get('examinerName')?.setErrors(null);*/

  }
  defaultStatements: { [key: string]: string } = {
    reportDescription: `<p>I report to the trustees on my examination of the accounts of ${this.charityName} (the Charity) for the year ended DD / MM / YYYY. </p>

                        <b>Responsibilities and basis of report</b>
                        <br/>

                        As the charity trustees of the Trust, you are responsible for the preparation of the accounts in accordance with the requirements of the Charities Act 2011 (the Act).

                        I report in respect of my examination of the Trust’s accounts carried out under section 145 of the 2011 Act and in carrying out my examination, I have followed the applicable Directions given by the Charity Commission under section 145(5)(b) of the Act.
                        <br/>

                        <b>Independent examiner's statement</b>
                        <br/>
                        I have completed my examination. I confirm that no material matters have come to my attention (other than that disclosed below *) in connection with the examination which gives me cause to believe that in, any material respect: 
                        <ul>
                        <li> accounting records were not kept in accordance with section 130 of the Act or </l>
                        <li> the accounts do not accord with the accounting records </l>

                        </ul>

                        <p>I have no concerns and have come across no other matters in connection with the examination to which attention should be drawn in order to enable a proper understanding of the accounts to be reached.</p>`


  }

  DefaultScotlandStatement(formControlName: any) {
    debugger

    if (this.BasicInformation[0]?.accounting_Method == 'Cash (Receipts & Payments)') {
      this.defaultScotlandStatements = {
        reportScotlandDescription: `<p>I report on the accounts of the charity for the year ended ${this.endDate}. </p>`,

        responsibilitiesExaminerDescription: `<p>The charity’s trustees are responsible for the preparation of the accounts in accordance with the terms of the Charities and Trustee Investment (Scotland) Act 2005 and the Charities Accounts (Scotland) Regulations 2006 (as amended).
                                         The charity trustees consider that the audit requirement of Regulation 10(1) (a) to (c) of the 2006 Accounts Regulations does not apply. It is my responsibility to examine the accounts as required under section 44(1) (c) of the Act and to state whether particular matters have come to my attention.</p>`,

        basisIndependentDescription: `<p>My examination is carried out in accordance with Regulation 11 of the 2006 Accounts Regulations. An examination includes a review of the accounting records kept by the charity and a comparison of the accounts presented with those records. It also includes consideration of any unusual items or disclosures in the accounts, and seeks explanations from the trustees concerning any such matters. The procedures undertaken do not provide all the evidence that would be required in an audit, and consequently I do not express an audit opinion on the view given by the accounts.</p> `,

        independentScotlandDescription: `<p>In the course of my examination, no matter has come to my attention [other than disclosed below*]:</p>
                                 <p>which gives me reasonable cause to believe that in any material respect the requirements:</p>
                                 <ul>
                                 <li>to keep accounting records in accordance with Section 44(1) (a) of the 2005 Act and Regulation 4 of the 2006 Accounts Regulations</li>
                                 <li>to prepare accounts which accord with the accounting records and comply with Regulation 8 of the 2006 Accounts Regulations
                                 have not been met, or</li>
                                 </ul>
                                 <p>to which, in my opinion, attention should be drawn in order to enable a proper understanding of the accounts to be reached.</p>`,
      }
    }

    else {
      this.defaultScotlandStatements = {
        reportScotlandDescription: `<p>I report on the accounts of the charity for the year ended ${this.endDate}. </p>`,

        responsibilitiesExaminerDescription: `<p>The charity’s trustees are responsible for the preparation of the accounts in accordance with the terms of the Charities and Trustee Investment (Scotland) Act 2005 and the Charities Accounts (Scotland) Regulations 2006 (as amended).
                                          The charity trustees consider that the audit requirement of Regulation 10(1) (a) to (c) of the 2006 Accounts Regulations does not apply. It is my responsibility to examine the accounts as required under section 44(1) (c) of the Act and to state whether particular matters have come to my attention.</p>`,

        basisIndependentDescription: `<p>My examination is carried out in accordance with Regulation 11 of the 2006 Accounts Regulations. An examination includes a review of the accounting records kept by the charity and a comparison of the accounts presented with those records. It also includes consideration of any unusual items or disclosures in the accounts, and seeks explanations from the trustees concerning any such matters. The procedures undertaken do not provide all the evidence that would be required in an audit, and consequently I do not express an audit opinion on the view given by the accounts.</p> `,

        independentScotlandDescription: `<p>In the course of my examination, no matter has come to my attention [other than disclosed below*]:</p>
                                 <p>which gives me reasonable cause to believe that in any material respect the requirements:</p>
                                 <ul>
                                 <li>to keep accounting records in accordance with Section 44(1) (a) of the 2005 Act and Regulation 4 of the 2006 Accounts Regulations</li>
                                 <li>to prepare accounts which accord with the accounting records and comply with Regulation 8 of the 2006 Accounts Regulations
                                 have not been met, or</li>
                                 </ul>
                                 <p>to which, in my opinion, attention should be drawn in order to enable a proper understanding of the accounts to be reached.</p>`,
      }
    }

    const selected = this.defaultScotlandStatements[formControlName];
    if (selected) {
      this.form.patchValue({
        [formControlName]: selected
      }, { emitEvent: false });
    }
  }
  defaultScotlandStatements: { [key: string]: string } = {
    reportScotlandDescription: `<p> I report on the accounts of the charity for the year ended DD / MM / YYYY.</p>

                        <b>Respective responsibilities of trustees and examiner</b>
                        <br/>

                       The charity’s trustees are responsible for the preparation of the accounts in accordance with the terms of the Charities and Trustee Investment (Scotland) Act 2005 and the Charities Accounts (Scotland) Regulations 2006 (as amended).The charity trustees consider that the audit requirement of Regulation 10(1) (a) to (c) of the 2006 Accounts Regulations does not apply. It is my responsibility to examine the accounts as required under section 44(1) (c) of the Act and to state whether particular matters have come to my attention.
                        <br/>
                       <b>Basis of independent examiner’s statement</b>
                        <br/>
                            My examination is carried out in accordance with Regulation 11 of the 2006 Accounts Regulations. An examination includes a review of the accounting records kept by the charity and a comparison of the accounts presented with those records. It also includes consideration of any unusual items or disclosures in the accounts, and seeks explanations from the trustees concerning any such matters. The procedures undertaken do not provide all the evidence that would be required in an audit, and consequently I do not express an audit opinion on the view given by the accounts.
                        <br/>

                        <b>Independent examiner's statement</b>
                        <br/>
                        In the course of my examination, no matter has come to my attention [other than disclosed below*]
                                 <p>which gives me reasonable cause to believe that in any material respect the requirements:</p>
                                 <ul>
                                 <li>to keep accounting records in accordance with Section 44(1) (a) of the 2005 Act and Regulation 4 of the 2006 Accounts Regulations</li>
                                 <li>to prepare accounts which accord with the accounting records and comply with Regulation 8 of the 2006 Accounts Regulations
                                 have not been met, or</li>
                                 </ul>
                                 <p>to which, in my opinion, attention should be drawn in order to enable a proper understanding of the accounts to be reached.</p>`
  }

  DefaultNIStatement(formControlName: any) {
    debugger

    if (this.BasicInformation[0]?.accounting_Method == 'Cash (Receipts & Payments)') {
      this.defaultNIStatements = {
        reportNIDescription: `<p>I report on the accounts of the ${this.charityName} for the year ended ${this.endDate}. </p>`,

        responsibilitiesExaminerNIDescription: `<p>As the charity trustees, who are also the directors of the company for the purposes of company law, you are responsible for preparing the accounts in accordance with the applicable requirements of the Companies Act 2006 and the relevant charity accounting and reporting requirements.</p>
                                               <p>Having satisfied myself that the company is not subject to an audit requirement under company law and is eligible for independent examination, my responsibility is to examine the accounts under section 65 of the Charities Act (Northern Ireland) 2008, follow the general directions issued by the Charity Commission for Northern Ireland, and report whether any matters have come to my attention.
                                               </p>`,

        basisIndependentNIDescription: `<p>I have examined the company’s accounts in accordance with section 65 of the Charities Act (Northern Ireland) 2008 and the general directions issued by the Charity Commission for Northern Ireland.</p>
                                       <p>My examination included a review of the accounting records maintained by the company and a comparison of the accounts presented with those records. It also included consideration of unusual items or disclosures and seeking explanations from the trustees concerning such matters.</p>
                                       My role is to report whether any material matters have come to my attention that give me cause to believe that:
                                       <ol>
                                       <li>The accounting records have not been properly maintained in accordance with section 386 of the Companies Act 2006.</li>
                                       <li>The accounts do not agree with the accounting records.</li>
                                       <li>The accounts do not comply with the applicable accounting requirements of the Companies Act 2006 and the methods and principles of the Charities Statement of Recommended Practice applicable to the charity.</li>
                                       </ol>`,
        independentNIDescription: `<p>I have completed my examination in relation to the matters listed above.</p>`,
      }
    }

    else {
      this.defaultNIStatements = {
        reportNIDescription: `<p>I report on the accounts of the ${this.charityName} for the year ended ${this.endDate}. </p>`,

        responsibilitiesExaminerNIDescription: `<p>As the charity trustees, who are also the directors of the company for the purposes of company law, you are responsible for preparing the accounts in accordance with the applicable requirements of the Companies Act 2006 and the relevant charity accounting and reporting requirements.</p>
                                               <p>Having satisfied myself that the company is not subject to an audit requirement under company law and is eligible for independent examination, my responsibility is to examine the accounts under section 65 of the Charities Act (Northern Ireland) 2008, follow the general directions issued by the Charity Commission for Northern Ireland, and report whether any matters have come to my attention.
                                               </p>`,
        basisIndependentNIDescription: `<p>I have examined the company’s accounts in accordance with section 65 of the Charities Act (Northern Ireland) 2008 and the general directions issued by the Charity Commission for Northern Ireland.</p>
                                       <p>My examination included a review of the accounting records maintained by the company and a comparison of the accounts presented with those records. It also included consideration of unusual items or disclosures and seeking explanations from the trustees concerning such matters.</p>
                                       My role is to report whether any material matters have come to my attention that give me cause to believe that:
                                       <ol>
                                       <li>The accounting records have not been properly maintained in accordance with section 386 of the Companies Act 2006.</li>
                                       <li>The accounts do not agree with the accounting records.</li>
                                       <li>The accounts do not comply with the applicable accounting requirements of the Companies Act 2006 and the methods and principles of the Charities Statement of Recommended Practice applicable to the charity.</li>
                                       </ol>`,
        independentNIDescription: `<p>I have completed my examination in relation to the matters listed above.</p>`,
      }
    }

    const selected = this.defaultNIStatements[formControlName];
    if (selected) {
      this.form.patchValue({
        [formControlName]: selected
      }, { emitEvent: false });
    }
  }
  defaultNIStatements: { [key: string]: string } = {
    reportNIDescription: `<p> I report on the accounts of the charity for the year ended DD / MM / YYYY.</p>

                        <b>Respective responsibilities of trustees and examiner</b>
                        <br/>

                       The charity’s trustees are responsible for the preparation of the accounts in accordance with the terms of the Charities and Trustee Investment (Scotland) Act 2005 and the Charities Accounts (Scotland) Regulations 2006 (as amended).The charity trustees consider that the audit requirement of Regulation 10(1) (a) to (c) of the 2006 Accounts Regulations does not apply. It is my responsibility to examine the accounts as required under section 44(1) (c) of the Act and to state whether particular matters have come to my attention.
                        <br/>
                       <b>Basis of independent examiner’s statement</b>
                        <br/>
                         I have examined the company’s accounts in accordance with section 65 of the Charities Act(Northern Ireland) 2008 and the general directions issued by the Charity Commission for Northern Ireland.
                         My examination included a review of the accounting records maintained by the company and a comparison of the accounts presented with those records.It also included consideration of unusual items or disclosures and seeking explanations from the trustees concerning such matters.
                         My role is to report whether any material matters have come to my attention that give me cause to believe that:
                         <ol>
                         <li>The accounting records have not been properly maintained in accordance with section 386 of the Companies Act 2006.</li>
                         <li>The accounts do not agree with the accounting records.</li>
                         <li> The accounts do not comply with the applicable accounting requirements of the Companies Act 2006 and the methods and principles of the Charities Statement of Recommended Practice applicable to the charity.</li>,
                         </ol>
                         <br/>
                        <b>Independent examiner's statement</b>
                        <br/>
                        <p>I have completed my examination in relation to the matters listed above.</p>`
  }

  GetProfessionalAdvisorsDetails() {
    debugger
    /*var charityid = localStorage.getItem('charityId');*/
    var charityid = localStorage.getItem('charityId') || this.charityID;
    this.Charity_Service.getProfessionalAdvisorDetails(charityid).subscribe((data: any) => {
      debugger
      this.ProfessionalAdvisorsDetails = data.entity
      this.filteredAdvisors1 = this.ProfessionalAdvisorsDetails?.filter((examiner: any) => examiner.professionalAdvisors_Type?.toLowerCase() === "independent examiner");
      const primaryExaminer = this.filteredAdvisors1?.find((Examiner: any) => Examiner.isPrimary === true)
      if (primaryExaminer && !this.form.get('examinerName')?.value) {
        this.form.get('examinerName')?.setValue(primaryExaminer?.professionalAdvisors_Name)
        this.AdvisorsID = primaryExaminer?.advisorsId;
        if (this.AdvisorsID)
        this.form.controls['AdvisorsID']?.setValue(this.AdvisorsID);
        //  this.form.get('examinerName')?.disable();
      }
      if (data.entity != null) {
        this.ProfessionalAdvisorsDetails_count = this.ProfessionalAdvisorsDetails?.length
        //this.filteredAdvisors1 = this.ProfessionalAdvisorsDetails.filter(
        //  (advisor: { professionalAdvisors_Type: string; }) => advisor.professionalAdvisors_Type === "Examiner"
        //);
        this.filteredAdvisors1 = this.ProfessionalAdvisorsDetails.filter(
          (advisor: { professionalAdvisors_Type: string }) =>
            advisor.professionalAdvisors_Type?.toLowerCase() === "examiner" || advisor.professionalAdvisors_Type?.toLowerCase() === "independent examiner"
        );
        if (this.AdvisorsID) {
          const selectedAdvisor = this.filteredAdvisors1.find((x: any) => x.advisorsId === this.AdvisorsID);
          if (selectedAdvisor) {
            this.form.get('examinerName')?.setValue(selectedAdvisor.professionalAdvisors_Name);
          }
        }
        //this.form.controls['reportDescription'].setValue()
        //this.form.controls['examinerName'].setValue(this.filteredAdvisors1[0]?.professionalAdvisors_Name);
        //if (this.form.controls['examinerName']?.value)
        //  this.form.controls['examinerName'].disable();
        this.ShowSpinner = false;
        this.dialog.closeAll();

      } else {
        this.ProfessionalAdvisorsDetails_count = 0
        //this.DefaultStatement('reportDescription')
      }

    })
  }
  GetCharityDetails() {
    this.Charities_Service.EditCharityDetails(this.charityID).subscribe((data: any) => {
      debugger
      this.createform()
      this.charityName = data[0].charity_Name
      //   this.endDate = moment(data[0].current_AP_End_Date).format('DD/MM/YYYY');

      this.CharithDetails = data[0]
      const ifScotland = this.CharithDetails?.jurisdiction_Charity === 'scotland';
      const ifNorthernIreland = this.CharithDetails?.jurisdiction_Charity === 'northern_ireland';
      if (ifScotland) {
        this.DefaultScotlandStatement('reportScotlandDescription');
        this.DefaultScotlandStatement('responsibilitiesExaminerDescription');
        this.DefaultScotlandStatement('basisIndependentDescription');
        this.DefaultScotlandStatement('independentScotlandDescription');
      }
      else if (ifNorthernIreland) {
        this.DefaultNIStatement('reportNIDescription');
        this.DefaultNIStatement('responsibilitiesExaminerNIDescription');
        this.DefaultNIStatement('basisIndependentNIDescription');
        this.DefaultNIStatement('independentNIDescription');
      }
      else {
        this.DefaultStatement('reportDescription')
        this.DefaultStatement('responsibilitiesDescription')
        this.DefaultStatement('independentDescription')
      }
      this.GetIndependentExaminerDetails();
    })
  }
  examinerData: any[];
  GetIndependentExaminerDetails(): void {
    debugger;

    // const financialPeriodsID = this.form.get('FinancialPeriodsID')?.value;
    this.service.GetIndependentExaminerDetails(this.currentPeriod).subscribe((res: any) => {
      this.createform()
      this.examinerData = res.entity;
      if (res.entity) {
        // alert('')
        debugger
        // console.log('Fetched successfully:', res.entity);

        this.form.patchValue({
          reportDescription: res.entity[0].reportDescription,
          independentDescription: res.entity[0].independentDescription,
          responsibilitiesDescription: res.entity[0].responsibilitiesDescription,
          reportScotlandDescription: res.entity[0].reportScotlandDescription,
          responsibilitiesExaminerDescription: res.entity[0].responsibilitiesExaminerDescription,
          basisIndependentDescription: res.entity[0].basisIndependentDescription,
          independentScotlandDescription: res.entity[0].independentScotlandDescription,
          reportNIDescription: res.entity[0].reportNIDescription,
          responsibilitiesExaminerNIDescription: res.entity[0].responsibilitiesExaminerNIDescription,
          basisIndependentNIDescription: res.entity[0].basisIndependentNIDescription,
          independentNIDescription: res.entity[0].independentNIDescription,
          //examinerName: this.filteredAdvisors1[0]?.professionalAdvisors_Name ? this.filteredAdvisors1[0]?.professionalAdvisors_Name:null,
          examinerName: res.entity[0].examinerName,
          approvalDate: new Date(res.entity[0].approvalDate),
          accountingBody: res.entity[0].accountingBody,
          CharityID: res.entity[0].charityID,
          FinancialPeriodsID: res.entity[0].financialPeriodsID,
          CreatedDate: new Date(res.entity[0].createdDate),
          Createdby: res.entity[0].createdby,
          Modifiedby: res.entity[0].modifiedby,
          ModifiedDate: new Date(res.entity[0].modifiedDate),
          CentralUserId: res.entity[0].centralUserId,
          UserId: res.entity[0].userId,
          AdvisorsID: res.entity[0].advisorsID
        });
        this.AdvisorsID = res?.entity[0]?.advisorsID;
        this.ischecked = res.entity[0].matter_of_Concern;
      } else {
        const ifScotland = this.CharithDetails?.jurisdiction_Charity === 'scotland';
        const ifNorthernIreland = this.CharithDetails?.jurisdiction_Charity === 'northern_ireland';
        if (ifScotland) {
          this.DefaultScotlandStatement('reportScotlandDescription');
          this.DefaultScotlandStatement('responsibilitiesExaminerDescription');
          this.DefaultScotlandStatement('basisIndependentDescription');
          this.DefaultScotlandStatement('independentScotlandDescription');
        }
        else if (ifNorthernIreland) {
          this.DefaultNIStatement('reportNIDescription');
          this.DefaultNIStatement('responsibilitiesExaminerNIDescription');
          this.DefaultNIStatement('basisIndependentNIDescription');
          this.DefaultNIStatement('independentNIDescription');
        }
        else {
          this.DefaultStatement('reportDescription')
          this.DefaultStatement('responsibilitiesDescription')
          this.DefaultStatement('independentDescription')
        }
      }
      this.GetProfessionalAdvisorsDetails();
    })

  }
  setVisibility(event: MatRadioChange) {
    debugger
    this.ischecked = event.value == 'Yes';
    this.MarkDirty()
  }
  //Backto previous page--sumit//
  BackToPrevious(event?: any): void {
    if (event) {
      event.preventDefault();
    }
    if (this.isDuirty()) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5>
             <p class="f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px">
               Are you sure you want to leave this page?<br>Data entered will not be saved.
             </p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.isdirty = false;
          this.datashare.setisdirty(false)
          this.form.markAsPristine()
          this.router.navigate(['trusteeannualreport']);
        }
      });
    } else {
      setTimeout(() => {
        this.form.markAsPristine()
        this.router.navigate(['trusteeannualreport']);
      }, 50);
    }
  }



  isDuirty(): any {
    if (this.form.dirty || this.isdirty) {
      return true
    } else { return false }

  }



  backToCharityOverView() {
    debugger

    if (this.isDuirty()) {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.form.markAsPristine()
          this.isdirty = false;
          this.datashare.setisdirty(false)
          localStorage.setItem('isFromBasicInfo', 'true')
          this.router.navigate(['/charity']);
        }
        else {
          // this.spinner.hide()
          return

        }
      })
    }
    else {
      this.form.markAsPristine()
      localStorage.setItem('isFromBasicInfo', 'true')
      this.router.navigate(['/charity']);
    }
  }


  isEditorEmpty(): boolean {
    const html = this.form.get('reportDescription')?.value || '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const plainText = tempDiv.textContent?.trim() || '';
    return plainText.length === 0;
  }

  DbDateConverter(ControllerDate: any) {
    if (ControllerDate) {
      const momentDate = moment(ControllerDate);
      const localMidnight = momentDate.startOf('day');
      const formattedDate = localMidnight.format('YYYY-MM-DDTHH:mm:ss.SS[Z]');
      //console.log(formattedDate);
      return formattedDate.toString();
    } else {
      return '';
    }
  }

  validateExaminer(event: any) {
    debugger
    if (event.target.value == null || event.target.value == "") {
      this.form.get('independentExaminerReportId')?.setErrors({ required: true })
      this.form.get('independentExaminerReportId')?.markAsTouched()
    } else {
      this.form.get('independentExaminerReportId')?.setErrors(null)
      this.form.get('independentExaminerReportId')?.markAsPristine()
    }

  }
  onaccounting(event?: any) {
    debugger
    this.accountBodyValue = event.value
    //  this.DefaultStatement('reportDescription')
    //  this.DefaultStatement('responsibilitiesDescription')
    this.DefaultStatement('independentDescription')
  }

  CurrentDate_Validate(Event?: any) {
    debugger
    const SelectedDate = moment(Event.target.value, 'DD/MM/YYYY', true);
    var CurApStartDate = moment(this.BasicInformation[0].current_AP_Start_Date)
    const isValidDate = SelectedDate.isValid();

    var nextstartdate = moment(new Date(), 'DD/MM/YYYY', true);
    if (Event.target.value != null) {
      if (!isValidDate) {
        this.form.get('approvalDate')?.setErrors({ InvalidDate: true })
      }
      else if (SelectedDate > nextstartdate || SelectedDate < CurApStartDate) {
        this.form.get('approvalDate')?.setErrors({ IsAfterToday: true })
      }
    } else {
      if (!this.form.get('approvalDate')?.errors)
        this.form.get('approvalDate')?.setErrors({ required: true })
    }

  }

  vldExamenirdateofapp(event: any) {
    debugger
    if ((event.target.value == null || event.target.value == "") && !(+this.form.get('approvalDate')?.getRawValue() > 0)) {
      this.form.get('approvalDate')?.setErrors({ required: true })
      this.form.get('approvalDate')?.markAsTouched()
    } else {
      this.form.get('approvalDate')?.setErrors(null)
      this.CurrentDate_Validate(event)

    }

  }


  //CurrentDate_Validate1(Event?: any) {
  //  debugger
  //  const SelectedDate = moment(Event.target.value, 'DD/MM/YYYY', true);
  //  var CurApEndDate = moment(localStorage.getItem('CurApEndDate'))
  //  //var _2015 = moment('01-01-2015')
  //  const isValidDate = SelectedDate.isValid();
  //  var SelecteDate = new Date(Event.target.value)
  //  var nextstartdate = new Date()
  //  if (!isValidDate) {
  //    this.form.get('approvalDate')?.setErrors({ InvalidDate: true })
  //  }
  //  else if (SelecteDate > nextstartdate) {
  //    this.form.get('approvalDate')?.setErrors({ IsAfterToday: true })
  //  }
  //  else if (SelectedDate < CurApEndDate) {
  //    this.form.get('approvalDate')?.setErrors({ IsBeforeAP: true })
  //  }

  //}




  enforceMaxLength(event: any): void {
    const input = event.target.value;
    if (input.length > 2500) {
      const trimmed = input.slice(0, 2500);
      event.target.value = trimmed;
      this.form.get('reportDescription')?.setValue(trimmed);
    }
  }



  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    //  ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  CanDeactivate(): any {
    debugger
    if (this.isDuirty()) {
      this.sharedService.updateisLoadingResults(false)
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          debugger
          this.isdirty = false;
          this.datashare.setisdirty(false)
          return true
        } else {
          return false
        }
      })
    } else {
      return true
    }
  }


  UnlockandAmend() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Amend) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Unlocking the accounting period will allow you to amend the filed accounts and correct any errors. After making any changes, the accounts must be submitted again as an Amended filing. Do you want to unlock and amend the accounting period?</p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid,'UnlockandAmend').subscribe((data: any) => {
            debugger
            this.form.get('examinerName')?.enable()
            this.form.get('approvalDate')?.enable()
            this.form.get('accountingBody')?.enable()
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted');
            localStorage.setItem('NewAmendCycle', 'true');
          })
          //this.save("FinaliseandClose");
        }
        else { }
      })
    }
    else {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  UnfreezeAP() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Do you want to unlock the Accounting Period? </p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid,'Unlock').subscribe((data: any) => {
            debugger
            this.form.get('examinerName')?.enable()
            this.form.get('approvalDate')?.enable()
            this.form.get('accountingBody')?.enable()
            const message = "Accounting Period unlocked successfully";
            this.msgService.showToastMessage('success', message)
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
          })
        }
      })
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  gotoSubmissions() {
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      this._UsermanagementService.GoToSubmissions()
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }

  }

  modalAddAdvisor(template: any) {
    debugger
    this.CreateProfessionalAdvisorsCommonForm();
    this.ProfessionalAdvisorsCommonForm.markAllAsTouched();
    this.ProfessionalAdvisorsCommonForm.patchValue({
      professionalAdvisors_Type: 'Independent Examiner',
    })
    this.ProfessionalAdvisorsCommonForm.controls['professionalAdvisors_Type'].disable()
    let dialogRef = this.dialog.open(template, {
      /* width: '40%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true*/
      //width: '40%', maxWidth: '100%', maxHeight: 'auto', height: '88vh', disableClose: true,
      width: '40%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true, panelClass: 'custom-dialog-container'
    });
  }

  CreateProfessionalAdvisorsCommonForm() {
    this.ProfessionalAdvisorsCommonForm = new FormGroup({
      professionalAdvisors_Type: new FormControl(null),
      professionalAdvisors_Name: new FormControl(null),
      professionalAdvisors_FirmName: new FormControl(null),
      professionalAdvisors_Address_Line_1: new FormControl(null),
      professionalAdvisors_Address_Line_2: new FormControl(null),
      professionalAdvisors_Address_Line_3: new FormControl(null),
      professionalAdvisors_City: new FormControl(null),
      professionalAdvisors_County: new FormControl(null),
      professionalAdvisors_Country: new FormControl(null),
      professionalAdvisors_Postcode: new FormControl(null),
      advisorsId: new FormControl(null),
      advisor_audited_Type: new FormControl('Individual Charity Auditor'),
      isPrimary: new FormControl(false)
    })
    this.addAdvisorbtn = true;
    this.updateAdvisorbtn = false;
  }
  AddAdvisor() {
    debugger
    this.edithead = false;
    this.ExId = [];
    const postCodeU = this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.value?.toUpperCase();
    this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.setValue(postCodeU);
    this.ExId = this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Name')?.value;
    if (!this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Type')?.value) {
      this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Type')?.setErrors({ required: true });
      this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Type')?.markAsTouched();
    }
    if (!this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Name')?.value) {
      this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Name')?.setErrors({ required: true });
    }
    if (this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Country')?.value &&
      !this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.value) {
      this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.setErrors({ required: true });
    }

    if (this.ProfessionalAdvisorsCommonForm.valid) {
      const charityId = +(localStorage.getItem('charityId') ?? '0');
      const form = this.ProfessionalAdvisorsCommonForm.getRawValue();

      const payload: any = {
        ...form, charityId,
      };


      delete payload.advisor_audited_Type;

      //console.log('Advisor payload →', payload);
      this.ShowSpinner = true;
      this.Charities_Service.saveAdvisor(payload).subscribe((data: any) => {
        this.msgService.showToastMessage('success', data.mesage);
        this.Charity_Service.getProfessionalAdvisorDetails(charityId).subscribe((res: any) => {
          this.ProfessionalAdvisorsDetails = res.entity;
          this.filteredAdvisors1 = this.ProfessionalAdvisorsDetails.filter((examiner: any) => examiner.professionalAdvisors_Type?.toLowerCase() === "independent examiner");
          if (this.filteredAdvisors1.length > 0) {
            debugger
            const examinername = this.filteredAdvisors1[this.filteredAdvisors1.length - 1];
            this.AdvisorsID = examinername?.advisorsId
            this.form.get('examinerName')?.setValue(examinername.professionalAdvisors_Name);
            if (this.AdvisorsID)
            this.form.get('AdvisorsID')?.setValue(this.AdvisorsID);
          }
        })
        this.ShowSpinner = false;
        this.dialog.closeAll();
        this.GetProfessionalAdvisorsDetails();

      });


    }
  }
  closeAdvisor() {
    debugger
    this.edithead = false;
    if (this.ProfessionalAdvisorsCommonForm.dirty) {
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">Are you sure you want to leave the page.<br\>Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          // this.adviserTypes = this.adviserTypes.filter(item => item !== (this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Type')?.value));
          if (this.examinerData?.length > 0) {
            const examinername = this.examinerData[0]?.examinerName;
            const advisorId = this.examinerData[0]?.advisorsID;
            this.form.get('examinerName')?.setValue(examinername);
            this.form.get('AdvisorsID')?.setValue(advisorId);
          }
          if (this.ExId?.length) {
            this.form.get('examinerName')?.setValue(this.ExId)
          }
          //else if (this.examinerData) {
          //  this.form.get('examinerName')?.setValue(this.examinerData[0]?.examinerName)
          //}
          else {
            const primaryExaminer = this.filteredAdvisors1?.find((Examiner: any) => Examiner.isPrimary === true)
            if (primaryExaminer && !this.form.get('examinerName')?.value) {
              this.form.get('examinerName')?.setValue(primaryExaminer?.professionalAdvisors_Name)
              this.AdvisorsID = primaryExaminer?.advisorsId;
              this.form.get('AdvisorsID')?.setValue(this.AdvisorsID );
            }
          }
          this.CreateProfessionalAdvisorsCommonForm();
          this.dialog.closeAll()
          return
        }
        else {
          return
        }
      })
    }
    else {
      //this.adviserTypes = this.adviserTypes.filter(item => item !== (this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Type')?.value));
      if (this.examinerData?.length > 0) {
        const examinername = this.examinerData[0]?.examinerName;
        const advisorId = this.examinerData[0]?.advisorsID;
        this.form.get('examinerName')?.setValue(examinername);
        this.form.get('AdvisorsID')?.setValue(advisorId);
      }
      if (this.ExId?.length) {
        this.form.get('examinerName')?.setValue(this.ExId)
      }
      //else if (this.examinerData) {
      //  this.form.get('examinerName')?.setValue(this.examinerData[0]?.examinerName)
      //}
      else {
        const primaryExaminer = this.filteredAdvisors1?.find((Examiner: any) => Examiner.isPrimary === true)
        if (primaryExaminer && !this.form.get('examinerName')?.value) {
          this.form.get('examinerName')?.setValue(primaryExaminer?.professionalAdvisors_Name)
          this.AdvisorsID = primaryExaminer?.advisorsId;
          this.form.get('AdvisorsID')?.setValue(this.AdvisorsID);
        }
      }
      this.CreateProfessionalAdvisorsCommonForm();
      this.dialog.closeAll()
      //  this.GetProfessionalAdvisorsDetails();
    }
    return
  }



  GetAllCountries() {

    this.Charities_Service.GetCountries().subscribe((data: any) => {

      this.AllCountriesList = data
    })
  }
  onDropdownOpened(event: KeyboardEvent) {
    debugger
    let key = event.key
    if (key === 'ArrowDown' && (this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Country')?.value === '' || this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Country')?.value === null)) {
      const firstCountry = this.AllCountriesList[0]?.countryID;
      this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Country')?.setValue(firstCountry, { emitEvent: false });
    }
  }
  validatepostcode(event: any) {
    debugger
    if (this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Country')?.value == 'United Kingdom' && this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.value) {
      if (!new RegExp(/^((([A-Z][0-9][0-9]?)|(([A-Z][A-HJ-Y][0-9][0-9]?)|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z])))) [0-9][A-Z]{2})$/).test(this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.value)) {
        this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.setErrors({ invalid: true })
      }
    }
    else {
      if (this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Country')?.value && !this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.value) {
        //this.ProfessionalAdvisorsForm.get('auditors_Details_postcode')?.setErrors({ required: true })
      }
      else {
        this.ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.setErrors(null)
      }

    }
  }
  onPrimaryExaminerChange(event: any) {
    debugger
    if (event.checked) {
      this.ProfessionalAdvisorsCommonForm.get('isPrimary')?.setValue(true);
    }
    else {
      this.ProfessionalAdvisorsCommonForm.get('isPrimary')?.setValue(false);
    }
  }
  enablePlainTextPaste(): void {
    this.pasteHandler = (event: ClipboardEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.ProseMirror')) {
        return;
      }
      event.preventDefault();
      const text = event.clipboardData?.getData('text/plain') || '';
      document.execCommand('insertText', false, text);
    };
    document.addEventListener('paste', this.pasteHandler, true);
  }
}
